// extracted by mini-css-extract-plugin
export var active = "_ua-1";
export var circle = "_ua-0";
export var completed = "_ua-2";
export var connector = "_ua-4";
export var connectorCompleted = "_ua-7";
export var connectorSpacer = "_ua-5";
export var iconStrokeOverride = "_ua-8";
export var labelContainer = "_ua-6";
export var pending = "_ua-3";